import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import shifaLogo from "src/assets/images/shifara-green-logo.png";
import httpRequest from "src/helpers/httpRequest";
import moment from "moment";
import { capitalize } from "@mui/material";
import { Loader } from "lucide-react";

const TitleAndList = ({
  title,
  list,
}: {
  title: string;
  list: string[] | undefined;
}) => {
  return (
    <div className="w-full flex flex-col gap-2">
      <p className="font-size-18px font-Poppins-SemiBold text-[#00443F]">
        {title}
      </p>
      <div className="w-full flex flex-col gap-2">
        {Array.isArray(list) ? (
          list?.map((item: string, index: number) => (
            <p
              key={index}
              className="font-size-15px font-Poppins-Regular text-[#2F2F31]"
            >
              {item}
            </p>
          ))
        ) : (
          <p className="font-size-15px font-Poppins-Regular text-[#2F2F31]">
            {list || "--"}
          </p>
        )}
      </div>
    </div>
  );
};

interface IPrescribedResponse {
  [key: string]: any;
}

const ViewPrescription = ({
  prescription,
  onClose,
  setCurrentDoctor,
}: {
  prescription: any;
  onClose: () => void;
  setCurrentDoctor: (doctor: any) => void;
}) => {
  const [isLoader, setIsLoader] = useState(false);
  const [prescribedData, setPrescribedData] = useState<any>(null);

  const readPrescription = async () => {
    const { res, err } = await httpRequest<IPrescribedResponse>({
      path: `/appoiment/read?prescribeId=${prescription?.id}&query=prescribe`,
    });
    if (res) {
      
    } else {
      toast(err, { type: "error" });
    }
  };

  const fetchData = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IPrescribedResponse>({
      path: `/appoiment/view-prescription?prescribeId=${prescription?.id}`,
    });
    if (res) {
      setPrescribedData(res?.document);
      if (!prescribedData?.customerNotified) {
        readPrescription();
        setCurrentDoctor((prev: any) => ({
          ...prev,
          redNotified: true
        }));
      }
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="w-full bg-white border border-gray-300 rounded-lg flex flex-col gap-2 2xl:gap-4 p-2 2xl:p-3">
      {isLoader ? (
        <div className="w-full flex gap-2 h-[100px] items-center justify-center">
          <Loader className="animate-spin" size={20} />
          Loading Prescription...
        </div>
      ) : (
        <>
          <div className="w-full">
            <img src={shifaLogo} alt="Shifa Logo" className="w-[120px]" />
            <p className="font-size-15px font-Poppins-Regular text-[#6D6D6D] mt-2">
              {prescribedData?.message}
            </p>
          </div>
          <div className="w-full flex flex-col gap-2">
            <p className="font-size-15px font-Poppins-Medium text-[#2A2A2A] flex gap-2 items-center">
              <span className="font-Poppins-Regular text-[#515151]">
                Name:{" "}
              </span>
              {prescribedData?.customerDetails?.firstName || ""}{" "}
              {prescribedData?.customerDetails?.lastName || ""}
            </p>
            <p className="font-size-15px font-Poppins-Medium text-[#2A2A2A] flex gap-2 items-center">
              <span className="font-Poppins-Regular text-[#515151]">
                Age/Gender:{" "}
              </span>
              {moment().diff(
                moment(prescribedData?.customerDetails?.age),
                "years"
              ) || ""}{" "}
              years /{" "}
              {capitalize(prescribedData?.customerDetails?.gender || "")}
            </p>
            <p className="font-size-15px font-Poppins-Medium text-[#2A2A2A] flex gap-2 items-center">
              <span className="font-Poppins-Regular text-[#515151]">
                Date:{" "}
              </span>
              {moment(prescribedData?.createdAt).format("DD-MM-YYYY") || ""}
            </p>
          </div>
          <TitleAndList
            title={prescribedData?.productType === "pharmacy" ? "Medicine" : prescribedData?.productType === "diagnostic" ? "Test" : "Homecare Service"}
            list={
              prescribedData?.prescribeDetails?.map(
                (item: any) =>
                  `${item?.productName} ${
                    item?.dosage
                      ? `| ${item?.dosage} Tab${item?.dosage > 1 ? "s" : ""}`
                      : ""
                  }`
              ) || []
            }
          />
          <TitleAndList
            title="Instructions"
            list={
              prescribedData?.prescribeDetails?.map(
                (item: any) => item?.instruction
              ) || []
            }
          />
        </>
      )}
    </div>
  );
};

export default ViewPrescription;
